module.exports = __webpack_public_path__ + "static/media/apple-logo.ff7f32c3.svg";